import React, { Fragment } from 'react';
import support from '../../../../images/supportticket.png';

const VehicleIssue = () => (
  <Fragment>
    <div className="faq__column--container">
      <p>During your booking, you may encounter various warning lights.</p>
      <br />
      <div>
        If any warning messages appear on the central display, please make
        your way back to the hub immediately so that we can resolve the
        issue.
      </div>
      <br />
      <div>Here are the messages that you may receive:</div>
      <ul>
        <li>Automatic vehicle hold disabled</li>
        <li>Steering assist reduced</li>
        <li>Traction control disabled</li>
        <li>Stability control disabled</li>
        <li>Regenerative braking disabled</li>
        <li>Automatic Emergency braking disabled</li>
        <li>Cruise Control disabled</li>
        <li>ABC (anti-lock braking system) disabled</li>
        <li>Front passenger safety restraint system fault</li>
        <li>12V battery must be replaced soon</li>
        <li>Car needs service</li>
        <li>Acceleration and top speed reduced</li>
        <li>Power reduced</li>
      </ul>
      <br />
      <p>
        If any of these issues occur, return the vehicle and Autzu will try
        to swap you into another vehicle once you return. If you require
        further assistance, please reach out to us by creating a support
        ticket within the Autzu app.
      </p>
      <br />
      <h4 className="subtitle">How to create a support ticket?</h4>
      <ol>
        <li>Open the Autzu app, select Menu > Contact us</li>
        <li>
          Tap “New support” and fill in the required information then press
          "Next".
        </li>
      </ol>
      <p>We will be sure to respond to you as soon as possible.</p>
      <div style={{ textAlign: 'center' }}>
        <img src={support} style={{ width: '200px', height: '455px' }} />
      </div>
    </div>
  </Fragment>
);

export default VehicleIssue;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/VehicleIssues.js/VehicleIssue.js